import { api } from '../../api.js';
import { config } from '../../config.js';

const actions = {
    FRONT_PARCELAS_ZONAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.parcelas.zonas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PARCELAS_ZONA_BUTACAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.parcelas.zona.butacas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PARCELAS_BLOQUEAR_PARCELAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.parcelas.bloquear-parcelas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PARCELAS_CARRITO_BORRAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.parcelas.carrito.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PARCELAS_GUARDAR_DATOS_COMPRADOR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.parcelas.carrito.guardar-datos-comprador'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PARCELAS_RESUMEN : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.parcelas.resumen'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }
}

export default {
    actions
};
